import { render } from "./ReportsLoader.vue?vue&type=template&id=37d5fb52&ts=true"
import script from "./ReportsLoader.vue?vue&type=script&lang=ts"
export * from "./ReportsLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__